import apiCall from "../../axios";
import queryString from "query-string";

const getThings = async (opts: any = null) => {
  try {
    let tail = `things`;
    if (opts) {
      // Ensure offset is a number
      if (opts.offset !== undefined) {
        opts.offset = Number(opts.offset);
      }
      // Ensure limit is a number
      if (opts.limit !== undefined) {
        opts.limit = Number(opts.limit);
      }

      const stringified = queryString.stringify(opts, {
        arrayFormat: 'comma'
      });
      console.log('API query:', stringified);
      tail += `?${stringified}`;
    }
    const res = await apiCall("GET", tail);
    console.log('API response:', res.data);
    return res.data;
  } catch (e) {
    console.error("Error fetching things:", e);
    throw e;
  }
};

export default getThings;
